<!--
@Author: MIYONGLE
@Desc: 资讯
@Date: 2021-04-23 16时
-->

<template>
  <div class="padding-bottom">
    <!--bannar-->
    <div class="bannar-img">
      <img src="../../../static/pc/newInfo/banner_news_1.png" alt="慧用工" />
      <div class="new_bannar">
        <span v-if="icpBtn">资讯中心</span>
        <span v-else>新闻中心</span>
        <span>实时掌握行业资讯及企业动态</span>
      </div>
    </div>
  
    <!-- 新闻列表 -->
    <div class="min-width-pc new-list-con">
      <div v-for="item in resNewsList" :key='item.index' @click="jumpPage(item.id)" class="new-list-item">

        <!--带图片-->
        <div v-if="item.titlePic" class="clearfix have-img-block">
          <img :src="item.titlePic" alt='新闻咨询'/>
          <div>
            <span class="hover-span">{{item.title}}</span>
            <span>{{item.description}}</span>
            <span>{{item.createDate}}</span>
            <p class="icp-btn"  v-if="icpBtn">¥3.00 阅读更多</p>
          </div>
        </div>

        <!--不带图片-->
        <div v-else class="no-img-block">
          <div>
            <span class="hover-span">{{item.title}}</span>
            <span>{{item.description}}</span>
            <span>{{item.createDate}}</span>
            <p class="icp-btn" v-if="icpBtn">¥3.00 阅读更多</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <el-pagination
      @current-change="handleCurrentChange"
      v-if="isDisplayPage"
      :page-size="8"
      class='paging-con'
      layout="prev, pager, next"
      :total="resData.totalCount">
    </el-pagination>

    <!-- 弹窗form -->
    <pc-form-dialog :source='source'><span class="pc-form-text">慧用工｜致力于助力每一个优秀的公司</span></pc-form-dialog>

    <el-dialog 
      :visible.sync="centerDialogVisible"
      width="1200px"
      id='dialogBox'
      :show-close=false
    > 
    <div class="center">
      <img @click="centerDialogVisible=false" class="close-btn" src="../../../static/pc/newInfo/icon_tanchuang_exit.png" alt="" />
      <p slot="title" class="title">¥3.00</p>
      <!-- <div class="icp-dialog">
        <img src="../../../static/pc/newInfo/img_zhanghuxinxi.png" alt="" />
        <div class="icp-dialog-text">
          <p>公司名称：海南慧薪科技有限公司</p>
          <p>开户行： 中国银行海南省分行洋浦分行营业部</p>
          <p>账号： 266283580782</p>
        </div>
      </div> -->
      <div class="icp-dialog1">
        <img src="../../../static/pc/newInfo/er_wei_ma.jpg" alt="" />
      </div>
      <div class="footer-text">通过二维码付费后可查看更多资讯</div>
    </div>   
    </el-dialog>
     <!-- 底部悬浮框 -->
    <pc-suspension-dialog :source="sourceF"></pc-suspension-dialog>

  </div>
</template>

<script>
  import {getNewAndInfoList} from "../../service/apis";
  import {HTTP_CODE} from "../../service/axios_constants";
  import {setSession,checkNull,getSession,changeUrl,setLocal} from "../../filters/filters";
  import pcFormDialog from '../../components/pcFormDialog.vue'
  import pcSuspensionDialog from "../../components/pcSuspensionDialog";

  export default{
    name: 'new-and-info',
    data(){
      return{
        paramQuery: {
          pageNum: 1,
          pageSize: 8
        },
        resData: {},
        resNewsList: {},
        indexArray: [] ,//下标数组
        isDisplayPage: false,
        source: '',
        sourceF: "",
        whichAddress: '',
        icpBtn:false,//只有在慧薪下用此处改成fasle，
        centerDialogVisible:false,//二维码弹窗
      }
    },

    components: {
      "pc-form-dialog": pcFormDialog,
      "pc-suspension-dialog": pcSuspensionDialog
    },

    created() {
      this.xhrRealTimeInfoList();
      if(!checkNull(getSession('pageNum'))){
        this.paramQuery.pageNum = getSession('pageNum');
        setSession('pageNum', this.paramQuery.pageNum)
      }

      // 只在慧薪域名下弹ICP处理用的二维码
      this.whichAddress = window.location.hostname;
      if((this.whichAddress === 'www.hvcin.com' || this.whichAddress === 'hvcin.com') ){
        this.icpBtn=true;
      }

      // source来源：：
      let hash = window.location.hash;
      this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=zx' : '&pageFrom=zx';
      this.sourceF = this.source + "_f";
    },

    watch: {
      resData: function () {
        this.$nextTick(() => {
          if(this.indexArray.length != 0){
            for(var item = 0; item < this.resData.totalCount; item++){
              if(this.indexArray.indexOf(item) > -1){
                Array.from(document.getElementsByClassName('new-list-item'))[item].children[0].style.borderBottom = 'none'
              }
            }
          }
        });
      }
    },

    mounted() {},

    methods:{

      //xhr -- 资讯列表
      xhrRealTimeInfoList(){
        let param = {...this.paramQuery};
        getNewAndInfoList(param).then(res=>{
          if (res.statusCode === HTTP_CODE.suc) {
            this.resData = res.data;
            this.resNewsList = res.data.list;
            this.isDisplayPage = !checkNull(this.resNewsList) ? true : false;
            //展示线：设计图需求 相邻的带图片模块，添加线且如果带图片是页面最后一条也不需要加线
            //紧挨着不带图片的模块不需要加线
            this.indexArray = [];
            var index = -1;
            for(let item of this.resNewsList){
              index ++;
              if(!checkNull(item.titlePic)){
                if(this.resNewsList.length > index +1){
                  if(checkNull(this.resNewsList[index+1].titlePic)){
                    // index 条目是图片组最后一条
                    this.indexArray.push(index);
                  }
                }else{
                  this.indexArray.push(index);
                }

                item.titlePic = changeUrl(item.titlePic)
              }
            }
          }
        })
      },

      //页面跳转
      jumpPage(id){
        var pathTemp,pathName = null;
        var path = window.location.hash;
        pathTemp = path.substring(path.indexOf("?"));
        
        //在慧薪下用此处改成不跳转页面，
        if(this.icpBtn){
          this.centerDialogVisible=true;
        }else{
          // 如果是带着?source跳转到详情页面的时候也需要带着相应的值
          if(path.indexOf("?source") > 0){
            pathName = path.substring(path.indexOf("=") + 1);
            this.$router.push({
              path: '/newsAndInfoDetail?id=' + id + '&source=' + pathName,
            })
          }else{
            this.$router.push({
              path: '/newsAndInfoDetail?id=' + id,
            })
          }
        }
        
      },

      //分页
      handleCurrentChange(val){
        this.paramQuery.pageNum = val;
        setSession('pageNum', this.paramQuery.pageNum)
        this.xhrRealTimeInfoList();
      }
    },
  }
</script>

<style>
   /* 分页 */
  .paging-con{
    margin-top:100px;
  }

  #dialogBox .el-dialog__header{
    background: #FFFFFF;
    /* display: none; */
  } 
  #dialogBox .close-btn{
    position: absolute;
    top: 23px;
    right: 19px;
  }
</style>

<style scoped="scoped" lang="scss">

  .bannar-img{
    width: 100%;
    height: 720px;
    position: relative;
    img{
      width: 100%;
      height: 100%;
    }

    .new_bannar{
      position: absolute;
      top: 326px;
      left: 50%;
      margin-left: -100px;
      span{
        display: block;
      }
      span:nth-child(1){
        font-family: PingFangSC-Semibold;
        font-size: 50px;
        color: #FFFFFF;
      }
      span:nth-child(2){
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #FFFFFF;
        margin-top: 14px;
      }

    }
  }
  
  .padding-bottom{
    padding-bottom: 88px;
  }
  .new-list-con{
    margin-top: 88px;
    .new-list-item:hover{
      background: #FFFFFF;
      box-shadow: 0 2px 14px 0 rgba(0,0,0,0.20);
      cursor: pointer;
      .hover-span{
        color: #1985ff;
        font-family: PingFangSC-Medium;
        text-align: justify;
      }
    }


    .new-list-item{
      cursor: pointer;

    }

    //带图片
    .have-img-block{
      border-bottom: 1px solid #E5E5E5;
      padding-bottom: 24px;
      position: relative;
      display: flex;
      justify-content: space-between;
      img{
        width: 266px;
        height: 177px;
        // float: left;
        border-radius: 8px;
        margin-top: 24px;
        margin-left: 10px;
      }

      div{
        // float: left;
        margin-left: 20px;
        width: 874px;

        span{
          display: inline-block;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        span:nth-child(1){
          font-size: 18px;
          font-weight: bold;
          color: #100F0F;
          line-height: 26px;
          max-height: 52px;
          margin-top: 24px;
          height: 52px;
          font-family: PingFangSC-Medium;
        }

        span:nth-child(2){
          font-size: 14px;
          color: #100F0F;
          line-height: 28px;
          margin-top: 14px;
          max-height: 50px;
          font-weight: inherit !important;
        }
        span:nth-child(3){
          font-size: 14px;
          color: #706F6F;
          position: absolute;
          bottom: 24px;
        }
        .icp-btn{
          float: right;
          width: 148px;
          height: 42px;
          line-height: 42px;
          margin-top: 25px;
          background: #1985FF;
          font-size: 14px;
          color: #FBFDFF;
          border-radius: 24px;
        }
      }
    }

    //不带图片
    .no-img-block{
      background: #F9FAFC;
      height: 217px;
      margin-top: 24px;
      position: relative;
      div{
        padding: 0 20px;
        box-sizing: border-box;
        span{
          display: inline-block;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
        span:nth-child(1){
          height: 65px;
          line-height: 65px;
          font-size: 18px;
          font-weight: bold;
          color: #100F0F;
          border-bottom: 1px solid #CFCFCF;
          -webkit-line-clamp: 1;
        }
        span:nth-child(2){
          line-height: 22px;
          font-size: 16px;
          -webkit-line-clamp: 2;
          // color: #100F0F;
          color: #545151;
          margin-top: 19px;
          line-height: 28px;
        }
        span:nth-child(3){
          font-size: 16px;
          color: #706F6F;
          position: absolute;
          bottom: 20px;
        }
        .icp-btn{
          float: right;
          width: 148px;
          height: 42px;
          line-height: 42px;
          margin-top: 25px;
          background: #1985FF;
          font-size: 14px;
          color: #FBFDFF;
          border-radius: 24px;
        }
      }
    }
  }

  //有关于慧薪让展示弹框的 
  #dialogBox .center{
      background-color: #fff;
      margin:0 auto;
      width:100%;
      text-align: center;
      .title{
        font-size: 32px;
        font-weight: 600;
        color: #100F0F;
        line-height: 45px;
      }
      .icp-dialog{
        display: block;
        margin:0 auto;
        margin-top: 25px;
        width: 696px;
        height: 240px;
        background: #F4F4F4;
        img{
          margin-top: 82px;
          margin-left: 69px;
          float: left;;
          width: 110px;
          height: 74px;
        }
        .icp-dialog-text{
          height: 108px;
          float: left;
          text-align: left;
          margin-top: 66px;
          margin-left: 76px;
          line-height: 36px;
        }
      }
      .icp-dialog1{
        margin: 0 auto;
        margin-top: 25px;
        width: 240px;
        height: 240px;
        img{
          width: 240px;
          height: 240px;
        }
      }
      .footer-text{
        margin:0 auto;
        margin-top: 36px;
        width: 466px;
        height: 35px;
        text-align: center;
        color: #FF7E3D;
        font-size: 24px;
      }
  }

</style>



// WEBPACK FOOTER //
// src/views/pc/newsAndInfo.vue